import axios from 'axios';

const uploadFile = async (file_metadata, file) => {
    const url = file_metadata.upload.url
    const data = new FormData()
    Object.keys(file_metadata.upload.fields).forEach(k => data.append(k,file_metadata.upload.fields[k]))
    data.append("file", file, file_metadata.backend_filename)
    return axios.post(
        url,
        data,
        { timeout: 10000 }
    )
}

export const uploadAttachment =  async (file, project_id, instance_id, post_id) => {
    const payload = {
        finished: [],
        failed: [],
        project_id,
        post_id
    }
    // URL for attachments. Get presigned upload URL
    const url = "/api/attachments"
    const uploadUrl = await axios
        .post(url + "?get_url=true", {
            filename : file.name, 
            file_type: 'attachment',
            project_id, 
            instance_id, 
            post_id,
            folder_id: null
        })
        .then(response => response.data)

    // Use presigned URL for upload and notify Flask backend
    await uploadFile(uploadUrl, file)
        .then(async () => payload.finished.push({...uploadUrl}))
        .catch(async error => payload.failed.push(
            // Append user filename to inform user in modal
            {...error.data, 
                file_id: uploadUrl.file_id,
                user_filename: uploadUrl.filename
            }
        ))
        .then(() => axios.post(url + "?upload_finished=true", payload))
    
    return payload
}

export const uploadFiles = async (files, project_id, instance_id=null, file_type, folder_id=null) => {
    // Create needed variables and await Flask to return upload URL's
    let upload_failed = false
    const payload = {
        finished: [],
        failed: [],
        project_id
    }
    const url = "/api/files"

    const uploadUrls = await axios
        .post(url + "?get_url=true", {
            files: [...files].map(f => ({filename: f.name})), 
            project_id, 
            instance_id, 
            file_type,
            folder_id
        })
        .then(response => response.data)
        .catch(error => {
            upload_failed = true
            return error.response.data
        })

    if (upload_failed) return {existing: true, files: uploadUrls}

    // Use requested upload URL's to upload every selected file
    // Update payload with finished and failed file uploads to show user
    await axios.all(
        uploadUrls.map( async (f,i) => {
            return uploadFile(f, files[i])
            .then(() => payload.finished.push(
                {
                    backend_filename: f.backend_filename,
                    file_id:f.file_id,
                }
            ))
            .catch(error => payload.failed.push(
                // Append user filename to inform user in modal
                {...error.data, 
                    file_id:f.file_id,
                    user_filename: f.filename
                }
            ))
        }))
        // Send payload to Flask to update database accordingly
        .then(() => axios.post(url + "?upload_finished=true", payload))
    // Return payload to notify user in modal
    return payload
}
